import React from 'react';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import HorizontalIconCard from '../member/HorizontalIconCard';
import PoweredByFN from '../member/PoweredByFN';

function getTerms(member) {
	if (undefined === member || undefined === member.term) {
		return "N/A";
	}
	
	return member.term;
}

function getTermYears(member) {
	let endDate, startDate;

	if (undefined === member || undefined === member.positions || 0 === member.positions.length) {
		return "";
	}
	if (!member.positions[0].endDate) {
		endDate = 'present';
	} else {
		endDate = new Date(member.positions[0].endDate).getFullYear();
	}

	const currentTitle = member.positions[0].title;
	for (let i = 0; i < member.positions.length && member.positions[i].title === currentTitle; i++) {
		startDate = new Date(member.positions[i].startDate).getFullYear();
	}

	return startDate + ' - ' + endDate;
}

function getFamily(member) {
	if (undefined === member || undefined === member.family) {
		return "N/A";
	}
	
	return member.family.split(";")[0];
}

function getChildren(member) {
	if (undefined === member || undefined === member.numberChildren) {
		return "N/A";
	}
	
	return 'Children ' + (member.numberChildren > 0 ? member.numberChildren : 'None');
}

function getEducation(member) {
	if (undefined === member || undefined === member.education || 0 === member.personEducation.length) {
		return ['N/A'];
	} 
	
	return [member.education[0]]
}

function getEducationExpanded(member) {
	const education = [];

	if (undefined === member || undefined === member.education || 0 === member.personEducation.length) {
		return ""
	} 
	
	member.education.forEach((item) => {
		education.push(item)
	})	
	education.shift()
	
	return education;
}

const useStyles = makeStyles({
	root: {
		maxWidth: '100%',
		marginTop: 20,
		paddingLeft: 20,
		paddingRight: 20,
		border: '1px solid #C8CCD1'
	},
	cardTitleText: {
		marginTop: 30,
		marginBottom: 20,
		color: '#333333',
		fontSize: 24,
		fontWeight: 600,
		letterSpacing: 0
	},
	row: {
		marginBottom: 10
	},
	anchorRow: {
		textAlign: 'right',
		display: 'inline-block',
		marginBottom: 20,
	},
	anchorText: {
		color: '#005383',
		fontWeight: 600,
	},
	poweredByText: {
		color: '#333333',
		fontSize: 14,
		letterSpacing: 0
	},
	infoIcon: {
		fill: '#005383',
		paddingLeft: 5,
		paddingRight: 10,
		width: 35
	},
	equalHeight: {
		display: 'flex', 
		width: '100%'
	}

});

const MemberBackgroundCard = ( member = {} ) => {
	
	const classes = useStyles();

	return (
		<>
		<Card className={classes.root} variant="outlined">
			<div className={classes.cardTitleText}>
				Background
			</div>
			<Grid container spacing={3} className={classes.row} alignItems="stretch">
				<Grid key="AGE" item className={classes.equalHeight} xs={12} sm={12} md={4}>
					<HorizontalIconCard
								imageURL={"https://member-pages.s3.us-east-2.amazonaws.com/icon-age.svg"}
								imageColor=""
								title="AGE"
								values={[member.age ? member.age : 'N/A']} />
				</Grid>
				<Grid key="CHILDREN" item className={classes.equalHeight} xs={12} sm={12} md={4}>
					<HorizontalIconCard
								imageURL={"https://member-pages.s3.us-east-2.amazonaws.com/icon-marital-status.svg"}
								imageColor=""
								title="MARITAL STATUS & CHILDREN"
								values={[getFamily(member), getChildren(member)]}  />
				</Grid>
				<Grid key="TERM" item className={classes.equalHeight} xs={12} sm={12} md={4}>
					<HorizontalIconCard
								imageURL={"https://member-pages.s3.us-east-2.amazonaws.com/icon-term.svg"}
								imageColor=""
								title="TERM"
								values={[getTerms(member), getTermYears(member)]} />
				</Grid>
			</Grid>
			<Grid container spacing={3} className={classes.row} alignItems="stretch">
				<Grid key="RESIDENCE" item className={classes.equalHeight} xs={12} sm={12} md={4}>
					<HorizontalIconCard
								imageURL={"https://member-pages.s3.us-east-2.amazonaws.com/icon-residence.svg"}
								imageColor=""
								title="RESIDENCE"
								values={[member.homeTown ? member.homeTown : 'N/A']} />
				</Grid>
				<Grid key="RELIGION" item className={classes.equalHeight} xs={12} sm={12} md={4}>
					<HorizontalIconCard
								imageURL={"https://member-pages.s3.us-east-2.amazonaws.com/icon-religion.svg"}
								imageColor=""
								title="RELIGION"
								values={[member.religion ? member.religion : 'N/A' ]} />
				</Grid>
				<Grid key="EDUCATION" item className={classes.equalHeight} xs={12} sm={12} md={4}>
					<HorizontalIconCard
								imageURL={"https://member-pages.s3.us-east-2.amazonaws.com/icon-book.svg"}
								imageColor=""
								title="EDUCATION"
								expand="true"
								values={getEducation(member)}
								schoolExpanded={getEducationExpanded(member)} />
				</Grid>
			</Grid>
			<PoweredByFN />
		</Card>
		</>
	);
}

export default MemberBackgroundCard;
